import {
  BrokerNerdsBarkerCoreModelsAdministrativeAppearanceSettings,
  BrokerNerdsBarkerCoreModelsAdministrativePrincipal,
  BrokerNerdsBarkerCoreModelsAdministrativePrincipalSettings,
} from '../../api';
import { useGlobalState } from '../../data/Global.state';

export const useAppearanceSettings = () => {
  const { principal } = useGlobalState('principal') as { principal: BrokerNerdsBarkerCoreModelsAdministrativePrincipal };
  const principalSettings = principal?.settings ?? ({} as BrokerNerdsBarkerCoreModelsAdministrativePrincipalSettings);
  return principalSettings.pricerSettings?.appearanceSettings as BrokerNerdsBarkerCoreModelsAdministrativeAppearanceSettings;
};
